/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IValueOperationScope extends ng.IScope {
        isReadonly: boolean;

        // Top level value operation has this set
        calculation: Wars.Domain.Model.Calculations.Calculation;
        isSystemLevel: boolean;

        // Any non top level value operation has this set
        parentValueOperation: Wars.Domain.Model.Calculations.ValueOperation;
        complexOperandIndex: number;

        getOperation(): Wars.Domain.Model.Calculations.ValueOperation;
        addOperand: () => void;
        delete: () => void;
        allowGreaterThanLessThanComparison(): boolean;
        getAllowableBooleanEvaluationOperandType(): string;
        firstOperandIsSpecified() : boolean;
    }

    export class ValueOperation implements IDirective {
        public templateUrl: string = './app/views/directives/calculate/valueOperation.html';
        public restrict: string = 'E';
        public controller = ['$scope', 'calculationService', ValueOperationController];
        public controllerAs = 'controller';
        public scope: any = {
            calculation: "=",
            parentValueOperation: "=",
            complexOperandIndex: "=",
            isReadonly: "=",
            isSystemLevel: "="
        };

        public link($scope: IValueOperationScope, element: JQuery, attrs: ng.IAttributes, controller: ValueOperationController) { }
    }

    export class ValueOperationController implements IController {
        
        constructor(private $scope: IValueOperationScope, private calculationService: services.CalculationService) {
            $scope.getOperation = () => this.getOperationInternal();
            $scope.addOperand = () => this.addOperandInternal();
            $scope.delete = () => this.deleteInternal();
            $scope.allowGreaterThanLessThanComparison = () => this.allowGreaterThanLessThanComparisonInternal();
            $scope.getAllowableBooleanEvaluationOperandType = () => this.getAllowableBooleanEvaluationOperandTypeInternal();
            $scope.firstOperandIsSpecified = () => this.firstOperandIsSpecifiedInternal();
        }

        private getOperationInternal(): Wars.Domain.Model.Calculations.ValueOperation {
            if (this.$scope.calculation) {
                return this.$scope.calculation.valueOperation;
            } else {
                var complexOperand = <Wars.Domain.Model.Calculations.ComplexOperand>this.$scope.parentValueOperation.operands[this.$scope.complexOperandIndex];
                return complexOperand.myValueOperation;
            }
        }

        private addOperandInternal(): void {
            this.calculationService.addNewSimpleOperandToValueOperation(this.getOperationInternal());
        }

        private deleteInternal(): void {
            if (this.$scope.calculation) {
                this.calculationService.deleteValueOperationChildren(this.getOperationInternal());
                this.getOperationInternal().entityAspect.setDeleted();
                this.$scope.calculation.valueOperation = undefined;
            } else {
                this.calculationService.replaceOperandWithNewSimpleOperand(this.$scope.parentValueOperation, this.$scope.complexOperandIndex);
            }
        }

        private allowGreaterThanLessThanComparisonInternal(): boolean {
            var operation = this.getOperationInternal();
            return this.calculationService.allowGreaterThanLessThanComparison(operation);
        }

        private getAllowableBooleanEvaluationOperandTypeInternal(): string {
            var operation = this.getOperationInternal();
            if (!operation) return "";
            var variableType = services.CalculationService.getOperandVariableType(operation.operands[0]);
            if (!variableType) return "";
            return variableType.toString();
        }

        private firstOperandIsSpecifiedInternal(): boolean {
            var operation = this.getOperationInternal();
            if (!operation) return false;
            return this.calculationService.isOperandSpecified(operation.operands[0]);
        }
    }
}

warsApp.registerDirective('ValueOperation', []);